import InventoryList from "pages/InventoryPages/InventoryList/InventoryList"
import React, { useMemo } from "react"
import { useParams } from "react-router-dom"

export default function InventoryTab({ setInventoryPage }) {
  const { stockId } = useParams()
  const vehicleId = stockId

  return (
    <InventoryList vehicleId={vehicleId} showBreadcrumb={false} className="" />
  )
}
